
import { takeLatest, put, call } from 'redux-saga/effects';
import {
    DOWNLOAD_RISKFACTOR_TEMPLATE,
    downloadRiskfactorTemplateSuccess,
    downloadRiskfactorTemplateFailure,
    UPLOAD_RISKFACTOR_TEMPLATE,
    uploadRiskfactorTemplateSuccess,
    uploadRiskfactorTemplateFailure
} from './action';
import { SCORE_DEFINATION } from '../../../config';
import { HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_HEADERS_FORMDATA } from '../../../constants';
import request from '../../../components/Utils/httpHelper';

export function* getRiskFactorTemplate(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/download/template/`;
    try {
        const result = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(downloadRiskfactorTemplateSuccess(result));
    } catch (err) {
        yield put(downloadRiskfactorTemplateFailure(err))
    }
}
export function* donwloadRiskFactorTemplate() {
    yield takeLatest(DOWNLOAD_RISKFACTOR_TEMPLATE, getRiskFactorTemplate);
}

export function* setRiskFactorTemplate(action) {
    let requestUrl = `${SCORE_DEFINATION}/riskfactor/add`;
    const formData = new FormData();
    formData.append('file', action.data);
    try {
        const result = yield call(request, requestUrl, { data: '', method:'GET', headers: HTTP_HEADERS_FORMDATA });
        yield put(uploadRiskfactorTemplateSuccess(result.data));
    } catch (err) {
        yield put(uploadRiskfactorTemplateFailure(err))
    }
}
export function* uploadRiskFactorTemplate() {
    yield takeLatest(UPLOAD_RISKFACTOR_TEMPLATE, setRiskFactorTemplate);
}